import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Chip, List, Radio, Typography } from '@material-ui/core';
import { priceFormat } from '../hooks/currency';

import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

const useStyles = makeStyles((theme) => ({

  content: {
    paddingBottom: theme.spacing(2), 
  },
  title: {
    paddingLeft: theme.spacing(2), 
    paddingRight: theme.spacing(2), 

    display: 'flex', 
    flexDirection:'column',
    justifyContent: 'flex-start', 
   
  },
  maximun: {
    display: 'flex', 
    flexDirection:'row',
    justifyContent: 'space-between', 
   
  },

}));



export default function Addition(props) {
  const classes = useStyles();
  const {addition,showCurrency, store, order,strings, onChanges} = props; 
  const currency = store.currency; 

  //console.log('addition: ',addition);

  const [checked, setChecked] = React.useState([]);
  const [disableOptions, setDisableOptions] = React.useState(false);
  const maxChecks = addition.maxOptions
  const maxStr = strings.additions_max_options.replace("${maxOptions}",maxChecks); 
 
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const isChecked = currentIndex >= 0
    let newChecked = [...checked];
    if(isChecked ){
      newChecked.splice(currentIndex,1);
      const ad = { 
        ...value,
        additionUid: addition.uid
      }
      handlerOnChanges('remove',ad); 
    }else if(checked.length<maxChecks){
      newChecked.push(value);
      const ad = { 
            ...value,
            additionUid: addition.uid
      }
      handlerOnChanges('add',ad);
    }else{
      console.debug('max checks'); 
    }
    //console.log('handleToggle newChecks: ',newChecked);
    setChecked(newChecked);
    setDisableOptions(newChecked.length>=maxChecks); 
  };

  const getStatus= (element)=>{
    const isChecked = checked.indexOf(element)!== -1; 
    let variant = 'disable'
    if(isChecked) 
        variant = 'checked'
    else if(!disableOptions){
      variant = 'enable'
    }    
    return variant
  }

  const getVariant= (status)=>{
    let variant; 
    if(status=='checked') 
        variant = 'h6'
    else if(status=='enable'){
      variant = 'body1'
    }else{
     variant = 'body2'
    }
    return variant
  }

  const getExtraPrice = (value)=>{
    if(!value.price || value.price<=0.0)
      return ""
   return "+" + priceFormat(currency.style,value.price,showCurrency); 
  }
  
  const getExtraPriceColor = (status)=>{
    let color; 
    if(status=='enable' || status=='checked') 
        color = 'accent.main'
    else color = 'text.muted'
    return color
   }

   const getOptionColor = (status)=>{
    let color; 
    if(status=='enable' || status=='checked') 
        color = 'text.primary'
    else   color = 'text.muted'

    return color
   }

  const getColorRequired=()=>{
      let color = "accent"; 
      const selected = checked.length; 
      if(addition.type== "REQUIRED" && selected < 1){
          color = "error"; 
      }
      return color; 
  }

  const handlerOnChanges = (event,ad)=>{
   if(onChanges){
     onChanges(event,ad); 
   }
  }

  return (
    <div className={classes.content}>  
       <div className={classes.title}>  
          <Typography variant="subtitle1">   {addition.name}</Typography>
          <div className={classes.maximun}>
          <Typography variant="body2"  color="text.muted">   {maxStr}</Typography>
          {addition.type == "REQUIRED" && 
          <Chip label={strings.additions_required} color={getColorRequired()} size="small"   />
          }
          </div>
          
      </div>

      <List>
          {
          addition.options.map((element)=>(
          
            <ListItem key={element.uid}>
              <Typography  variant ={getVariant(getStatus(element))}
                            color ={getOptionColor(getStatus(element))}> {element.name} </Typography>
              <Typography  ml={1} variant ={getVariant(getStatus(element))} 
                          color ={getExtraPriceColor(getStatus(element))}> {getExtraPrice(element)}
              </Typography>
              <ListItemSecondaryAction>

              <Radio
                onClick={handleToggle(element,this)}
                checked={checked.indexOf(element) !== -1}
                disabled = {checked.indexOf(element) === -1 && disableOptions}
                inputProps={{ 'aria-labelledby': `switch-list-label-${element.uid}` }}
                color="accent"
              />
              </ListItemSecondaryAction>
            </ListItem>
          ))
          }
    </List>
    </div>
  );
}
